// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36zOh","colBig":"styles_colBig__1_n8E","colSmall":"styles_colSmall__2S1NQ"};